export default __webpack_public_path__ + "ed6ce2593547c8eeaf503bd4c69282c5.svg";